module.exports = __webpack_public_path__ + "img/logo1.44600e34.svg";